<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useStatusStore } from '@/stores/status'
import { useAudioDevices } from '@/composables/useAudioDevices'

const { status } = storeToRefs(useStatusStore())
const { audio } = useAudioDevices()
</script>

<template>
  <div v-if="status == 'oncall'" class="w-fit mx-auto">
    <div class="float-left mr-[10px]">
      <i class="material-icons float-left text-[#073b4c] text-[12px]! mr-[2px]">headset</i>
      <div
        v-for="index in 5"
        :key="index"
        class="w-[7px] h-[5px] mt-[2px] float-left rounded-[2px] ml-[1px]"
        :style="{
          backgroundColor: index < audio.outputVolume ? '#5cb85c' : '#D3D3D3',
        }"
      />
    </div>

    <div class="float-left">
      <i class="material-icons float-left text-[#073b4c] text-[12px]!">mic</i>
      <div
        v-for="index in 5"
        :key="index"
        class="w-[7px] h-[5px] mt-[2px] float-left rounded-[2px] ml-[1px]"
        :style="{
          backgroundColor: index < audio.inputVolume ? '#5cb85c' : '#D3D3D3',
        }"
      />
    </div>
  </div>
</template>
